import React, { Component } from 'react';
import InlineSVG from 'svg-inline-react';

import Input from 'components/Input';

import './select-prod-card';

import { formatPrice } from '../../util';

export default class SelectProdCard extends Component {

	constructor(props) {
		super(props);
	}

	selectProduct (event) {
		if(event.target.checked){
			this.props.addProduct(this.props.id);
		} else {
			this.props.removeProduct(this.props.id);
		}
	}

	componentWillUpdate(nextState) {
		//let total = 0;
		//console.log('component gonna update');
	}


	total () {
	}

	render () {
		return (
			<div className="select-prod-card">
				<input
					type="checkbox"
					checked={this.props.selected}
					id={this.props.id}
					name={this.props.name}
					onChange={this.selectProduct.bind(this)}
				/>
				<div className="content">
					<div className="flex-grid">
						<div className="col grow">
							<label htmlFor={this.props.id}>
								<h3 className="title">{this.props.name}</h3>
								<div className="cost-info">{formatPrice(this.props.price, null, 'SelectProductCard')} pre Student</div>
							</label>
						</div>
						<div className="col options">
							<div className="option-row">
								<Input
									name="studentCount"
									type="number"
									value={this.props.studentCount || ''}
									inputClass="small"
									placeholder="100"
									id="qty"
									onChange={this.props.updateProduct.bind(this, this.props.id)}
								/>
								<label htmlFor="qty">Students</label>
							</div>
							<div className="option-row">
								<Input
									name="discount"
									type="number"
									value={this.props.discount || ''}
									inputClass="small"
									placeholder="$0.00"
									id="discount"
									onChange={this.props.updateProduct.bind(this, this.props.id)}
								/>
								<label htmlFor="discount">Discount</label>
							</div>
							{ this.props.total ?  (
							<div className="option-row total">
								<label>Total</label>
								<div className="total green">{formatPrice(this.props.total, null, 'SelectProductCard')}</div>
							</div>
							) : (
							<div className="option-row total">
								<label>Total</label>
								<div className="total">$0.00</div>
							</div>
							)}
						</div>

					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./js/components/SelectProdCard/SelectProdCard.js